if (!customElements.get('gf-locale-sheet')) {
  customElements.define('gf-locale-sheet', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-open]');
        if (trigger) {
          const dialog = this.querySelector('[data-sheet="' + trigger.dataset.open + '"]');
          if (!dialog) return;
          this.trigger = trigger; this.previousOverflow = document.documentElement.style.overflow;
          dialog.showModal(); trigger.setAttribute('aria-expanded', 'true');
          document.documentElement.style.overflow = 'hidden';
        }
        if (event.target.closest('[data-close]')) event.target.closest('dialog').close();
      }, {signal});
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientY < rect.top || event.clientX < rect.left || event.clientX > rect.right)) dialog.close();
        }, {signal});
        dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.trigger?.setAttribute('aria-expanded', 'false'); this.trigger?.focus();
        }, {signal});
      });
      this.onResize = () => { if (innerWidth >= 750) this.querySelectorAll('dialog[open]').forEach(d => d.close()); };
      window.addEventListener('resize', this.onResize, {signal});
    }
    disconnectedCallback() {
      if (this.querySelector('dialog[open]')) document.documentElement.style.overflow = this.previousOverflow || '';
      this.abort?.abort();
    }
  });
}
